module.exports = __webpack_public_path__ + "a1db804e068fd257350ad9f14ce9281d.png";